import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactStarts from "react-rating-stars-component";
import { CiStar } from "react-icons/ci";
import { RiDeleteBinLine } from "react-icons/ri";
import { removeFromCart } from "../../../../slices/cartSlice";
import Spinner from "../../../common/Spinner";
import GetAvgRating from "../../../../utils/avgRating";

const RenderCartCourses = ({cart}) => {
  // const { cart } = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  return (
    <div className="flex flex-1 flex-col">
      {
        cart.length ==0 
        ?(<Spinner />)
        :
        (cart.map((course,indx) => (
            <div 
            key={course._id}
            className={`flex w-full flex-wrap items-start justify-between gap-6 ${
              indx !== cart.length - 1 && "border-b border-b-richblack-400 pb-6"
            } ${indx !== 0 && "mt-6"} `} 
            >
              <div className="flex flex-1 flex-col gap-4 xl:flex-row">
                <img 
                src={course?.thumbnail} alt="" 
                className="h-[148px] w-[220px] rounded-lg object-cover"
                />
                <div className="flex flex-col space-y-1">
                  <p className="text-lg font-medium text-richblack-5">{course?.courseName}
                  </p>
                  <p className="text-sm text-richblack-300">
                    {course?.category?.name}
                    </p>
                  <div className="flex items-center gap-2">
                    {/* PENDING : rating ki original value add krna baki hai  */}
                    <span className="text-yellow-5">{course?.ratingCount ? course?.ratingCount : 4.6}</span>
                    {/* package use karenge */}
                    <ReactStarts
                      count={5}
                      value={4}
                      size={20}
                      isHalf={true}
                      emptyIcon={<CiStar />}
                      fullIcon={<CiStar />}
                      halfIcon={<CiStar />}
                      activeColor="#ffd700"
                    />
                    <span className="text-richblack-400">
                      {course?.ratingAndReview?.length} Ratings
                      </span>
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-end space-y-2">
                <button 
                onClick={()=>dispatch(removeFromCart(course._id))}
                className="flex items-center gap-x-1 rounded-md border border-richblack-600 bg-richblack-700 py-3 px-[12px] text-pink-200"
                >
               < RiDeleteBinLine />
               <span>Remove</span>
                </button>
                <p  className="mb-6 text-3xl font-medium text-yellow-100">
                 ₹ {course?.price}</p>
              </div>
            </div>
          )))    
      }
          </div>
  );
};

export default RenderCartCourses;
